import { render, staticRenderFns } from "./leaderboard-views-reach-table.vue?vue&type=template&id=4473b1ee&scoped=true&"
import script from "./leaderboard-views-reach-table.vue?vue&type=script&lang=js&"
export * from "./leaderboard-views-reach-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473b1ee",
  null
  
)

export default component.exports